import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./style.css";
import { getAboutAris } from "../../Services/aboutAris";
import { useHeader } from "../../Providers/HeaderContextProvider";

function AboutAris() {
  const [aboutData, setAboutData] = useState(null);
  const { setHeaderContent } = useHeader();
  const navigate = useNavigate();

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setHeaderContent(false);
    const fetchAboutData = async () => {
      try {
        const field = "about_aris";
        const response = await getAboutAris(field);
        if (response) {
          setAboutData(response);
        }
      } catch (error) {
        console.error("Error fetching about data:", error);
      }
    };

    fetchAboutData();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const handleNavigation = () => {
      navigate(-1);
    }

    if(aboutData) {
      document.querySelector(".about-aris-logo-container").addEventListener("click", handleNavigation);
      document.querySelector(".about-aris-navigate-icon div").addEventListener("click", scrollToTop);
    }

    return () => {
      document.querySelector(".about-aris-logo-container").removeEventListener("click", handleNavigation);
      document.querySelector(".about-aris-navigate-icon div").addEventListener("click", scrollToTop);
    };
  }, [aboutData]);

  return (
    <>
    {aboutData && (
      <div dangerouslySetInnerHTML={{__html: aboutData.content}}></div>
    )}
    </>
  );
}

export default AboutAris;
